$('.fileInput').on('change', function (event) {
    var file = event.target.files[0];
    if (!file) return;

    const apiKey = 'f6105e6522a21f53ded98221d2932040'; // 🔁 Replace with your ImgBB API key
    const uploadBox = $(this).closest(".upload-box");
    const memoryInput = $(this).closest(".upload-section");
    const uploadStatus = uploadBox.find('.uploadStatus');
    const uploadImageBtn = $(this).siblings(".upload-image__btn");

    // Clear previous state
    uploadStatus.empty();
    uploadBox.removeClass("active");

    var formData = new FormData();
    formData.append('image', file);

    // Show uploading message
    uploadStatus.append('<p class="uploading">Uploading...</p>');

    fetch(`https://api.imgbb.com/1/upload?key=${apiKey}`, {
        method: 'POST',
        body: formData
    })
    .then(res => res.json())
    .then(data => {
        uploadStatus.empty();

        if (data.success) {
            const imageUrl = data.data.url;

            // Add edit icon if not already added
            if (!memoryInput.find(".edit-img").length) {
                memoryInput.prepend(`
                    <div class="edit-img">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <path d="M9.33398 22.684L15.218 22.664L28.0607 9.94403C28.5647 9.44003 28.842 8.7707 28.842 8.0587C28.842 7.3467 28.5647 6.67737 28.0607 6.17337L25.946 4.0587C24.938 3.0507 23.1793 3.05603 22.1793 4.0547L9.33398 16.7774V22.684ZM24.0607 5.94403L26.1793 8.0547L24.05 10.164L21.9353 8.0507L24.0607 5.94403ZM12.0007 17.8894L20.0407 9.92537L22.1553 12.04L14.1167 20.0014L12.0007 20.008V17.8894Z" fill="#E97E3D"/>
                            <path d="M6.66667 28H25.3333C26.804 28 28 26.804 28 25.3333V13.776L25.3333 16.4427V25.3333H10.8773C10.8427 25.3333 10.8067 25.3467 10.772 25.3467C10.728 25.3467 10.684 25.3347 10.6387 25.3333H6.66667V6.66667H15.796L18.4627 4H6.66667C5.196 4 4 5.196 4 6.66667V25.3333C4 26.804 5.196 28 6.66667 28Z" fill="#E97E3D"/>
                        </svg>
                    </div>
                `);
            }

            // Show image
            uploadStatus.append(`<img src="${imageUrl}" style="max-width:100%;">`);

            // Add hidden input
            if (!memoryInput.find('input[name="image_url"]').length) {
                memoryInput.append(`<input type="hidden" name="image_url" value="${imageUrl}">`);
            } else {
                memoryInput.find('input[name="image_url"]').val(imageUrl);
            }

            // Final UI updates
            uploadBox.addClass("active");
            uploadImageBtn.addClass("hide");

        } else {
            uploadStatus.append('<p>Upload failed. Please try again.</p>');
        }
    })
    .catch(err => {
        console.error(err);
        uploadStatus.append('<p>Upload error. Check console.</p>');
    });
});

$(document).on("click",".edit-img",function() {
    var uploadBox = $(this).siblings(".upload-box");

    // Debugging check
    if (uploadBox.length === 0) {
        console.log("No parent .upload-box found.");
        return;
    }

    var fileInput = uploadBox.find(".fileInput");
    var uploadBtn = uploadBox.find(".upload-image__btn");
    var emptyStatus = uploadBox.find(".uploadStatus");

    // Check if fileInput and uploadBtn are found
    if (fileInput.length === 0) {
        console.log("No .fileInput found.");
    } else {
        fileInput.click(); // Trigger the file input click
    }
});